
import { Stack } from "@mui/material";
import AlarmScheduleEditorUtils, { AlarmScheduleFormType } from "./AlarmScheduleEditorUtils";
import { useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import { addDays, differenceInDays } from "date-fns";

import { DayOfWeekEnum } from "../../../services/alarm-schedule-data-service/Models";
import SquareChip from "../../../components/square-chip/SquareChip";

type BlackoutPreviewType = {
    title: string;
    label: string;
    dayOfWeek: number;
    checked: boolean;
    
    inRange: boolean;
}

export default function BlackoutPreview() { 

    const [previewData, setPreviewData] = useState<BlackoutPreviewType[]>([]);

    const {
        watch
//    ,   getValues
//    ,   resetField
//    ,   setValue
//    ,   trigger
    } = useFormContext<AlarmScheduleFormType>();

    const [
        repeat,
        startDate,
        endDate,
        setBlackoutHours,
        setBlackoutDays,
        blackoutSchedules
    ] = watch([
        'repeat',
        'dateRange.startDate',
        'dateRange.endDate',
        'setBlackoutHours',
        'setBlackoutDays',
        'blackoutSchedules'
    ]);

    const blackoutSchedule = blackoutSchedules.length > 0 ? blackoutSchedules[0] : undefined;

    useEffect(() => {
        const data: BlackoutPreviewType[] = [];

        if (blackoutSchedule) {

            const start = startDate ?? new Date();
            let end = endDate ?? new Date();

            let durationDays = differenceInDays(end, start);
            let repeatDays = AlarmScheduleEditorUtils.getRepeatDays(repeat);
            const days = 30;

            // try and handle the case where duration unit is in hours
            if (durationDays === 0) {
                durationDays = 1;
            }

            if (repeatDays === 0) {
                repeatDays = 1;
            }

            end = addDays(start, days);

            let current = startDate as Date;

            let intervalDay = 0;

            while(current.getTime() < end.getTime()) {

                const currentDay = current.getDay();

                if (intervalDay < repeatDays) {

                    const inRange = intervalDay < durationDays;

                    const checked = inRange ?
                                        setBlackoutDays ?
                                            ((currentDay === DayOfWeekEnum.Sunday && blackoutSchedule.sunday) ||
                                            (currentDay === DayOfWeekEnum.Monday && blackoutSchedule.monday) ||
                                            (currentDay === DayOfWeekEnum.Tuesday && blackoutSchedule.tuesday) ||
                                            (currentDay === DayOfWeekEnum.Wednesday && blackoutSchedule.wednesday) ||
                                            (currentDay === DayOfWeekEnum.Thursday && blackoutSchedule.thursday) ||
                                            (currentDay === DayOfWeekEnum.Friday && blackoutSchedule.friday) ||
                                            (currentDay === DayOfWeekEnum.Saturday && blackoutSchedule.saturday)) :
                                         //User Story 53044: Research - 2025 Q2 - Review GAS report
                                        setBlackoutHours /*&& !setBlackoutDays*/ ? true :
                                        false :
                                    false;
                    data.push({
                        title: AlarmScheduleEditorUtils.getDayOfWeekLabel(currentDay),
                        label: current.getDate().toString(),
                        dayOfWeek: currentDay,
                        checked: checked,
                        inRange: inRange
                    });
                }

                current = addDays(current, 1);

                if (++intervalDay >= repeatDays) {
                    intervalDay = 0;
                }
            }
        }

        setPreviewData(data);

    }, [
        setPreviewData,
        startDate,
        endDate,
        repeat,
        repeat.unit,
        repeat.value,
        blackoutSchedule,
        blackoutSchedule?.sunday,
        blackoutSchedule?.monday,
        blackoutSchedule?.tuesday,
        blackoutSchedule?.wednesday,
        blackoutSchedule?.thursday,
        blackoutSchedule?.friday,
        blackoutSchedule?.saturday,
        setBlackoutDays,
        setBlackoutHours
    ]);

    return (
        <Stack direction='row' sx={{
            flexWrap: 'wrap'
        }}>
            {previewData.map((o, ndx) => (

                <SquareChip 
                    key={ndx}
                    header={o.title}
                    label={o.label}
                    size="medium"
                    colorOverride={o.inRange ? 'secondary' : undefined}
                    //checkedColorOverride="primary"
                    disabled={!setBlackoutDays && !setBlackoutHours}
                    checked={o.checked}
                    sx={{
                        background:  setBlackoutDays && o.checked ?
                                        '#000' :
                                     setBlackoutHours && o.inRange ? 
                                        'linear-gradient(to bottom right, #000 50%, rgba(42, 199, 180, 1) 50%)' : 
                                        undefined
                    }}
                    />
            ))}
        </Stack>
    );
}

